import { PlusOutlined } from '@ant-design/icons';
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { FormItem, useRelationEditor } from '@framework/form';
import { VerticalSpace } from '@framework/ui';
import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useBasicDndDragger } from '../../../../../ui/dnd/hooks/useBasicDndDragger';
import { FieldDatatype } from '../../../datatype/Datatype';
import { IReference } from '../../../references/IReference';
import { AssignableExpressionInput } from '../../assignable/input/AssignableExpressionInput';
import { ISwitchExpressionCase } from '../ISwitchExpression';
import { SwitchExpressionCaseSchema } from '../SwitchExpressionSchema';
import { SortableSwitchExpressionItem } from './SortableSwitchExpressionItem';

const SwitchExpressionInputWrapper = styled.div`
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 16px;
`;

export interface ISwitchExpressionInputProps {
  name: string;
  fieldRef: FieldDatatype;
  references: IReference[];
}

export function SwitchExpressionInput(props: ISwitchExpressionInputProps) {
  const { name, fieldRef, references } = props;

  const editor = useRelationEditor<ISwitchExpressionCase>(`${name}.cases`);
  const { sensors, handleDragStart, handleDragEnd, itemIds, active } =
    useBasicDndDragger(editor);

  return (
    <SwitchExpressionInputWrapper>
      <DndContext
        sensors={sensors}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
          {editor.items.map((item, index) => (
            <SortableSwitchExpressionItem
              active={active}
              key={item.__uid ?? '<unknown>'}
              uid={item.__uid ?? '<unknown>'}
              name={name}
              index={index}
              references={references}
              fieldRef={fieldRef}
              onRemove={() => {
                editor.removeAt(index);
              }}
            />
          ))}
        </SortableContext>
      </DndContext>
      <Button
        block
        onClick={() => {
          editor.append(SwitchExpressionCaseSchema.cast({}, { assert: false }));
        }}
        icon={<PlusOutlined />}
        type="primary"
        size="large"
      >
        Aggiungi condizione
      </Button>
      <div>
        <VerticalSpace size={12} />
        Se nessuna condizione viene rispettata:
        <VerticalSpace size={12} />
        <FormItem
          name={`${name}.defaultValue`}
          label="Valore di default"
          layout={{ removeMargin: true }}
        >
          <AssignableExpressionInput
            size="large"
            block
            references={references}
            name={`${name}.defaultValue`}
            field={fieldRef}
          />
        </FormItem>
      </div>
    </SwitchExpressionInputWrapper>
  );
}
